import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import css from './Spinner.module.scss';
import classNames from 'classnames';

export interface ComponentProps {
    /**
     * width/height of spinner. Default '4rem'
     */
    size?: string;
    /**
     * Thickness of spinner. Default 3.6
     */
    thickness?: number;
    /**
     * Optional styles to apply
     */
    className?: string;
    /**
     * Overrides color of the spinner. Default is theme color
     */
    color?: React.CSSProperties['color'];
}

export const GMSpinner: React.FC<ComponentProps> = ({ size = '4rem', thickness = 3.6, ...props }) => {
    return (
        <Box
            className={classNames(css.root, props.className)}
            style={{
                height: size,
                width: size,
            }}
        >
            <CircularProgress
                thickness={thickness}
                className={css.spinner}
                size={size}
                style={
                    props.color ? {
                        color: props.color,
                    } : undefined
                }
            />
        </Box>
    );
};